import { useState } from 'react';
import { usedictionaries } from '../../../../entities/dictionaries';
import type { ApplicationDocumentsFiltersValue } from '../../lib/filtertypes';
import { ApplicationDocumentsFilters } from './filters';
import { ApplicationDocumentsList } from './list';

export const ApplicationDocumentsTab = () => {
  const { applicationDocumentTypeOptions } = usedictionaries();
  const [filters, setFilters] = useState<ApplicationDocumentsFiltersValue>({
    search: '',
    period: 'all',
  });

  return (
    <div className="flex flex-col pt-4">
      <div className="p-4 bg-white -mb-1 rounded-lg border border-gray-200">
        <ApplicationDocumentsFilters
          value={filters}
          onChange={setFilters}
          documentTypeOptions={applicationDocumentTypeOptions}
        />
      </div>
      <ApplicationDocumentsList filters={filters} />
    </div>
  );
};
